import { useNavigate } from 'react-router-dom';

import { AppIcon, PageHeader } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  openNewPlaylistDialog,
  openNewTaskDialog,
} from '@backrs_ui/grow-ui/src/redux/priorities/priorities.slice';

import { Button, SxProps, Theme } from '@mui/material';

const HEADER_STRINGS = appStrings.modules.priorities.header;

export const PrioritiesHeader = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleAddTask = () => {
    dispatch(openNewTaskDialog({ playlist: null, shouldAutoOpenPlaylistDrawer: false }));
  };

  const handleAddPlaylist = () => {
    dispatch(openNewPlaylistDialog());
  };

  const buttons = [
    <Button
      key="bookmarks"
      id="priorities-bookmarks-button"
      variant="contained"
      hierarchy="Secondary gray"
      size="md"
      onClick={() => navigate(APP_ROUTE.BOOKMARKS)}
      startIcon={<AppIcon iconName="Bookmark" diameter="20px" color="currentColor" />}
    >
      {HEADER_STRINGS.viewBookmarks}
    </Button>,
    <Button
      key="add-task"
      id="priorities-add-task-button"
      variant="contained"
      hierarchy="Secondary gray"
      size="md"
      onClick={handleAddTask}
      startIcon={<AppIcon iconName="Edit05" diameter="20px" color="currentColor" />}
    >
      {HEADER_STRINGS.addTask}
    </Button>,
    <Button
      key="add-playlist"
      id="priorities-add-playlist-button"
      variant="contained"
      hierarchy="Primary"
      size="md"
      onClick={handleAddPlaylist}
      startIcon={<AppIcon iconName="Plus" diameter="20px" color="currentColor" />}
    >
      {HEADER_STRINGS.addPlaylist}
    </Button>,
  ];

  return (
    <PageHeader
      title={HEADER_STRINGS.title}
      rightComponents={buttons}
      maxWidth={1240}
      sxOverrides={{ container: prioritiesHeaderSx }}
    />
  );
};

const prioritiesHeaderSx: SxProps<Theme> = () => ({
  border: 'unset',
});
